import enMessages from "../locales/en";

const EnLang = {
  messages: {
    ...enMessages
  },
  locale: "en-US"
};
export default EnLang;
